import type { AxiosResponse } from 'axios';

import type {
  Evaluation,
  EvaluationsResponse,
} from '../evaluation.types';
import type { RunEvaluationApplication } from '@/features/runEvaluation/components/RunEvaluationDialog/RunEvaluationDialog.types';

export type EvaluationsListPage = AxiosResponse<EvaluationsResponse>;

interface SortEvaluationsByGeneratedAtOptions {
  excludeEmpty?: boolean;
}

export const sortEvaluationsByGeneratedAt = (
  evaluations: Evaluation[],
  { excludeEmpty = false }: SortEvaluationsByGeneratedAtOptions = {},
) => {
  const items = excludeEmpty
    ? evaluations.filter((item) => item.totalEvaluations)
    : evaluations;

  return items.sort(
    (left, right) =>
      new Date(right.generatedAt).getTime() -
      new Date(left.generatedAt).getTime(),
  );
};

export const normalizeEvaluationsListPage = (
  response: EvaluationsListPage,
  options?: SortEvaluationsByGeneratedAtOptions,
): EvaluationsListPage => {
  return {
    ...response,
    data: {
      ...response.data,
      items: sortEvaluationsByGeneratedAt(response.data.items, options),
    },
  };
};

export const getEvaluationRows = (
  pages?: EvaluationsListPage[],
) => {
  const rows = pages?.flatMap((page) => page.data.items) ?? [];

  if (rows[0]?.totalEvaluations === 0) {
    return [];
  }

  return rows;
};

export const getEvaluationTrendData = (evaluationRows: Evaluation[]) => {
  const items = evaluationRows.slice(0, 10).reverse();

  return items.length > 0
    ? items
    : [{ generatedAt: new Date().toISOString(), score: 0 }];
};

export const getRunEvaluationApplicationFromEvaluation = (
  evaluation: Evaluation | null | undefined,
): RunEvaluationApplication | null => {
  if (!evaluation) return null;

  return {
    bitId: evaluation.bitId,
    name: evaluation.applicationName,
    environment: evaluation.environmentNames[0],
  };
};
